import Grid from '@mui/material/Grid';
import {getShopDetails} from 'ultra/helpers/shop';

import {useNavigationStore} from '../../../../../../../../Stores/navigation';
import {useConfigStore} from '../../../../../../../../Stores/config';

import CurrencyFormated from '../../../../../../../../Components/CurrencyFormated';

import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import ShopingCart from '../../../../../../Widgets/ShopingCart'
import ContentImage from '../../../../../../Widgets/ContentImage'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import ShopProductPrice from '../../../../../../Widgets/ShopProductPrice'
import FilterChip from '../../../../../../Widgets/FilterChip'
import Gallery from '../../../../../../Widgets/Gallery';

import './index.scss'

export default function Template(props) {
    const {content, permits, config, breadcrumbs} = props

    const {configs} = useConfigStore();

    const {shop} = getShopDetails(content, breadcrumbs)

    return <div className="Product MotoTemplate">
        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle}/>
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <div className='photoWrap'>
                    <ContentImage src="thumbnail" image={content.thumbnail} className="photo" />
                    {content.status && <div className="photoLabel">
                        <FilterChip value={content.status} config={configs.content.nodes['shop-product'].fields.status} />
                    </div>}
                </div>
                <Gallery content={content.gallery} />
            </Grid>
            <Grid item xs={12} md={6}>
                <ShopProductPrice product={content} currency={shop?.partner_config?.currency} sufix={shop?.partner_config?.priceSufix} />

                <ShopingCart
                    item={content}
                    shop={shop}
                    fullWidth
                />

                {!content.available && <div className='notAvailable'>Тимчасово недоступний</div>}

                {content["price3-6"] && <div className="labelWrap">
                    <span className="label">
                        Ціна за 3-6 днів:
                    </span>
                    <span className="labelValue">
                        <CurrencyFormated value={content["price3-6"]} currency={shop?.partner_config?.currency} sufix="/на день"/>
                    </span>
                </div>}

                {content["price7-14"] && <div className="labelWrap">
                    <span className="label">
                        Ціна за 7-14 днів:
                    </span>
                    <span className="labelValue">
                        <CurrencyFormated value={content["price7-14"]} currency={shop?.partner_config?.currency} sufix="/на день"/>
                    </span>
                </div>}

                <CKEditorContent content={content.description} />

                {content.year && <div className="labelWrap">
                    <span className="label">
                        Рік випуску:
                    </span>
                    <span className="labelValue">
                        {content.year}
                    </span>
                </div>}

                {content["moto-category"] && <div className="labelWrap">
                    <span className="label">
                        Категорія:
                    </span>
                    <span className="labelValue">
                        {content["moto-category"]}
                    </span>
                </div>}

                {(content["moto-engine"] || content["moto-cylinder"]) && <div className="labelWrap">
                    <span className="label">
                        Двигун:
                    </span>
                    <span className="labelValue">
                        {content["moto-engine"] && <>{content["moto-engine"]} см³</>}
                        {content["moto-engine"] && content["moto-cylinder"] && <>,&nbsp;</>}
                        {content["moto-cylinder"] && <>{content["moto-cylinder"]} циліндри</>}
                    </span>
                </div>}

                {content["moto-power"] && <div className="labelWrap">
                    <span className="label">
                        Потужність:
                    </span>
                    <span className="labelValue">
                        {content["moto-power"]} к.с.
                    </span>
                </div>}

                {content["moto-max-torgue"] && <div className="labelWrap">
                    <span className="label">
                        Максимальний крутний момент:
                    </span>
                    <span className="labelValue">
                        {content["moto-max-torgue"]} Нм
                    </span>
                </div>}
            </Grid>
        </Grid>

        {/* <Links
            links={children}
            order={config.childrenOrder || content.childrenOrder}
        /> */}
    </div>
}
